var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedTransaction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Insufficient_balance_illustration",
    width: 180.255,
    height: 102.427,
    viewBox: "0 0 180.255 102.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-9{fill:#e9edf1}.cls-2{fill:#cdd2dc}.cls-3{fill:#753bbd}.cls-11,.cls-5{fill:#fff}.cls-9{opacity:.209}.cls-10{fill:#bac0cd}.cls-11{opacity:.74}.cls-12,.cls-13{fill:none}.cls-12{stroke:#bac0cd}.cls-15{stroke:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5110",
    transform: "translate(14130 -9654.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20212",
    d: "M-14269.812 9918.455s-21.312-43.185 20.544-79.968 44.552-15.641 39.523-10.319-20.652 27.106-14.843 41.982 28.36 35.554 60.614 3.974 39.97-39.817 59.579-15.563 2.488 61.161 2.488 61.161l-168.945-1.267",
    className: "cls-1",
    transform: "translate(145.237 -162.722)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4239",
    d: "M0 0H180V1H0z",
    className: "cls-2",
    transform: "translate(-14130 9756)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5101",
    transform: "translate(137 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4206",
    d: "M2 0h2v71H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z",
    className: "cls-3",
    transform: "translate(-14201 9686)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4204",
    width: 42,
    height: 75,
    fill: "#8a5aea",
    rx: 2,
    transform: "translate(-14197 9682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4207",
    d: "M0 0h1a2 2 0 0 1 2 2v67a2 2 0 0 1-2 2H0V0z",
    className: "cls-3",
    transform: "translate(-14155 9686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4205",
    d: "M0 0H32V31H0z",
    className: "cls-5",
    transform: "translate(-14192 9696.787)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4211",
    fill: "#f5f8fb",
    d: "M0 0H26V11H0z",
    transform: "translate(-14189 9680)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4212",
    width: 32,
    height: 2,
    fill: "#474e5d",
    rx: 1,
    transform: "translate(-14192 9691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4217",
    d: "M0 0H32V3H0z",
    className: "cls-1",
    transform: "translate(-14192 9725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4219",
    d: "M0 0H3V31H0z",
    className: "cls-1",
    transform: "translate(-14192 9697)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5101-2",
    transform: "translate(-14186.488 9683.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4222",
    d: "M0 0H3V7H0z",
    className: "cls-2",
    transform: "translate(.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4223",
    d: "M0 0H1V7H0z",
    className: "cls-2",
    transform: "translate(4.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4224",
    d: "M0 0H1V7H0z",
    className: "cls-2",
    transform: "translate(6.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4225",
    d: "M0 0H3V7H0z",
    className: "cls-2",
    transform: "translate(8.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4226",
    d: "M0 0H1V7H0z",
    className: "cls-2",
    transform: "translate(12.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4227",
    d: "M0 0H1V7H0z",
    className: "cls-2",
    transform: "translate(14.488 .383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4228",
    d: "M0 0H4V7H0z",
    className: "cls-2",
    transform: "translate(16.488 .383)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5104",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20213",
    d: "M0 0h24v4H0z",
    className: "cls-2",
    transform: "translate(-14075 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4264",
    fill: "#fff",
    d: "M0 0H4V4H0z",
    opacity: 0.736,
    transform: "translate(-14056 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4265",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14058 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4266",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14060 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4267",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14062 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4268",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14064 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4269",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14066 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4270",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14068 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4271",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14070 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4272",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14072 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4273",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14074 9748)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5105",
    transform: "translate(-2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4263",
    d: "M0 0H24V4H0z",
    className: "cls-10",
    transform: "translate(-14075 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4264-2",
    d: "M0 0H4V4H0z",
    className: "cls-11",
    transform: "translate(-14056 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4265-2",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14058 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4266-2",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14060 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4267-2",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14062 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4268-2",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14064 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4269-2",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14066 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4270-2",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14068 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4271-2",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14070 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4272-2",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14072 9748)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4273-2",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14074 9748)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5107",
    transform: "translate(-1 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4282",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14043 9736)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4283",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14043 9741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4284",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14043 9746)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4285",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14032 9736)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4286",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14032 9741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4287",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14032 9746)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4288",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14054 9736)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4289",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14054 9741)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4290",
    width: 8,
    height: 4,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14054 9746)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5108"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4291",
    width: 5,
    height: 2,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14042 9728)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4292",
    width: 5,
    height: 2,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14035 9728)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4293",
    width: 5,
    height: 2,
    className: "cls-5",
    rx: 1,
    transform: "translate(-14049 9728)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4251",
    d: "M0 0H24V4H0z",
    className: "cls-2",
    transform: "translate(-14021 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20216",
    d: "M0 0h4v4H0z",
    className: "cls-11",
    transform: "translate(-14002 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4253",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14004 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4254",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14006 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4255",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14008 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4256",
    d: "M0 0H1V4H0z",
    className: "cls-1",
    transform: "translate(-14010 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4257",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14012 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4258",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14014 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4259",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14016 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4260",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14018 9752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4261",
    d: "M0 0H1V4H0z",
    className: "cls-9",
    transform: "translate(-14020 9752)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2439",
    className: "cls-12",
    transform: "translate(-14093 9683)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    className: "cls-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2440",
    className: "cls-12",
    transform: "translate(-14080 9730)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    className: "cls-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2441",
    className: "cls-12",
    transform: "translate(-13996 9689.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    className: "cls-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2442",
    className: "cls-12",
    transform: "translate(-13962 9723)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    className: "cls-15"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2,
    className: "cls-13"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2443",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-13",
    transform: "translate(-14090 9703)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2444",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-10",
    transform: "translate(-14073 9699)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2445",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-10",
    transform: "translate(-14106 9716.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2446",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-10",
    transform: "translate(-13994.5 9721.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2447",
    cx: 1,
    cy: 1,
    r: 1,
    className: "cls-10",
    transform: "translate(-13968 9700)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun_X_1890844",
    transform: "translate(95.64 60.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5111",
    transform: "translate(-8.64 -8.665)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20217",
    fill: "#8a5aea",
    stroke: "#8a5aea",
    strokeWidth: "0.5px",
    d: "M37.581 28.908a.589.589 0 0 0-.8 0l-3.533 3.528-3.533-3.528a.568.568 0 0 0-.8.8l3.533 3.528-3.533 3.528a.587.587 0 0 0 0 .8.562.562 0 0 0 .8 0l3.533-3.528 3.533 3.528a.562.562 0 0 0 .8 0 .587.587 0 0 0 0-.8l-3.532-3.524 3.533-3.528a.587.587 0 0 0-.001-.804z",
    transform: "translate(-28.75 -28.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedTransaction);
export default __webpack_public_path__ + "static/media/failed-transaction.222a26427e1d40158d3579ae3c81b785.svg";
export { ForwardRef as ReactComponent };